import { useLingui } from "@lingui/react/macro";
import {
  differenceInDays,
  differenceInHours,
  differenceInMonths,
  startOfToday,
  subDays,
  subHours,
  subMonths,
} from "date-fns";

const today = startOfToday();

export enum SearchTimePeriod {
  Last24Hours = "24_H",
  Last7Days = "7_D",
  Last30Days = "30_D",
  Last3Months = "3_M",
}

export function usePredefinedTimeIntervals() {
  const { t } = useLingui();

  return [
    {
      label: t`Senaste 24 timmarna`,
      value: {
        id: SearchTimePeriod.Last24Hours,
        date: subHours(today, 24),
      },
    },
    {
      label: t`Senaste 7 dagarna`,
      value: {
        id: SearchTimePeriod.Last7Days,
        date: subDays(today, 7),
      },
    },
    {
      label: t`Senaste 30 dagarna`,
      value: {
        id: SearchTimePeriod.Last30Days,
        date: subDays(today, 30),
      },
    },
    {
      label: t`Senaste 3 månaderna`,
      value: {
        id: SearchTimePeriod.Last3Months,
        date: subMonths(today, 3),
      },
    },
  ];
}

export function getTimePeriodFromDate(startDate: Date) {
  if (differenceInHours(today, startDate) === 24) {
    return SearchTimePeriod.Last24Hours;
  }

  if (differenceInDays(today, startDate) === 7) {
    return SearchTimePeriod.Last7Days;
  }

  if (differenceInDays(today, startDate) === 30) {
    return SearchTimePeriod.Last30Days;
  }

  if (differenceInMonths(today, startDate) === 3) {
    return SearchTimePeriod.Last3Months;
  }
}
